/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
// src/components/seo.js

import Head from 'next/head';

import config from '../config';

interface Props {
	description: string;
	title: string;
	robots?: string;
	jsonLd?: string[];
	url: string;
	children?: React.ReactChild | React.ReactChildren;
	image?: string;
}

export default function SEO({
	description,
	title,
	robots,
	jsonLd,
	children,
	url,
	image = 'https://bitbns.com/assets/img/banners/og__banner.jpg',
}: Props) {
	const siteTitle = config.title;

	return (
		<Head>
			<title>{`${title} | ${siteTitle}`}</title>
			<meta name="description" content={description} />
			{robots && <meta name="robots" content={robots} />}
			<meta property="og:type" content="website" />
			<meta property="og:url" content={url} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:site_name" content={siteTitle} />
			<meta property="twitter:card" content="summary" />
			<meta property="twitter:url" content={url} />
			<meta property="twitter:creator" content={config.social.twitter} />
			<meta property="twitter:title" content={title} />
			<meta property="twitter:description" content={description} />
			<meta property="twitter:image" content={image} />
			<meta property="og:image" content={image} />
			<link rel="canonical" href={url} />
			{Array.isArray(jsonLd) &&
				jsonLd.map(schema => (
					<script
						type="application/ld+json"
						key={schema}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: schema,
						}}
					/>
				))}
			{children}
		</Head>
	);
}
